import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// We use custom text-ui-* classes for our typography system.
// By default, tailwind-merge assumes any class starting with `text-` that it doesn't recognize
// is a text color utility (like text-red-500). If we combine a typography class (text-ui-body)
// with a color class (text-muted-foreground), tailwind-merge will strip out the typography class
// thinking they conflict. This configuration teaches tailwind-merge that these specific classes
// belong to the font-size group instead.
const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "ui-display",
            "ui-title-1",
            "ui-title-2",
            "ui-title-3",
            "ui-body",
            "ui-body-sm",
            "ui-body-xs",
            "ui-label",
            "ui-eyebrow",
            "ui-metric",
            "ui-metric-sm",
            "ui-code",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}

/**
 * Formats AI message content by adding emojis, removing double asterisks,
 * and styling special sections like sources.
 */
export function formatAIContent(content: string): string {
  // Remove double asterisks from headings and keywords
  let formatted = content.replace(/\*\*(.*?)\*\*/g, "$1");

  // Add emojis to common section indicators
  formatted = formatted.replace(/^(Kostnad|Kostnader):/gim, "💰 $1:");
  formatted = formatted.replace(/^(Risker):/gim, "⚠️ $1:");
  formatted = formatted.replace(/^(Fördelar|Möjligheter):/gim, "✅ $1:");
  formatted = formatted.replace(/^(Material):/gim, "📦 $1:");
  formatted = formatted.replace(/^(Tidsåtgång|Tidplan):/gim, "⏱️ $1:");
  formatted = formatted.replace(/^(Sammanfattning):/gim, "📋 $1:");
  formatted = formatted.replace(/^(AMA)(-| |:)/gim, "🧱 AMA$2");
  formatted = formatted.replace(/^(Entreprenad):/gim, "🛠️ $1:");

  return formatted;
}
